var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBacknew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41947 0.572266L1.2998 4.69193L5.41947 8.81159",
    stroke: "#282828",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4541 4.69141H14.001",
    stroke: "#282828",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacknew);
export default __webpack_public_path__ + "static/media/backnew.851ddfc7c64c78e4ca8f38522c674256.svg";
export { ForwardRef as ReactComponent };